import type { Permission, Role } from "../api/types";

export const GRANTABLE_ROLES: readonly Role[] = ["sub_admin", "admin"];

export const ROLE_LABELS: Record<Role, string> = {
  employee: "Employee",
  sub_admin: "Sub-admin",
  admin: "Admin",
};

export const ROLE_DESCRIPTIONS: Record<Role, string> = {
  employee: "Raises and follows their own tickets.",
  sub_admin: "Works and assigns tickets, and raises them for others. No admin access.",
  admin: "Full access, including people, groups and settings.",
};

/** What each permission lets someone do, in plain words (for "what you can do" lists). */
export const PERMISSION_LABELS: Record<Permission, string> = {
  raise_ticket: "Raise and follow your own tickets",
  raise_on_behalf: "Raise tickets for colleagues, such as someone who can't sign in",
  use_workspace: "Work tickets in the workspace",
  view_reports: "See reports",
  view_audit_log: "See the audit log",
  manage_people_and_roles: "Manage people, roles and groups",
  manage_catalogue: "Manage the service catalogue",
  manage_settings: "Change support desk settings",
  view_delivery_failures: "See notifications that failed to send",
  answer_chats: "Answer chats from employees",
  post_service_updates: "Post announcements and service status",
};
